// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"9b939485","243":"29d45873","253":"affdc34b","303":"d17327e9","487":"924150be","645":"2ac06dd4","825":"08142008","834":"5f444487"}[chunkId] + ".chunk.js";
};